import { type LocationModel } from "src/types/location";

export interface FileItem {
  id: string;
  name: string;
  type: "file";
  file: LocationFileDto;
}

export interface FolderItem {
  id: string;
  name: string;
  type: "folder";
  location: LocationModel;
}

export type DataItem = FileItem | FolderItem;

export function isFolderItem(item: DataItem): item is FolderItem {
  return item.type === "folder";
}

export function isFileItem(item: DataItem): item is FileItem {
  return item.type === "file";
}
